import React, { ReactNode } from 'react'
import Tooltip from '@mui/material/Tooltip'

interface HoverTooltipProps {
  children: ReactNode
  message: string
  // width (px) of the actual interactive element to anchor the tooltip to, so it centers over it and not any sibling label text
  anchorWidth?: number | string    
}

const HoverTooltip: React.FC<HoverTooltipProps> = ({
  children,
  message,
  anchorWidth = 'fit-content',  
}) => {
  return (
    <Tooltip
      title={message}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#fff',
            color: '#000',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            fontSize: '0.95rem',
            borderRadius: '6px',
            border: '1px solid #ddd',
          },
        },
        arrow: {
          sx: {
            color: '#fff',
          },
        },
      }}
      PopperProps={{     
        modifiers: [
          {
            // pull tooltip closer so the arrow touches the toggle
            name: 'offset',
            options: { offset: [0, 2] },
          },
        ],
      }}  
      placement="top"
    >
      <span style={{ display: 'inline-block', width: anchorWidth }}>  
        {children}
      </span>
    </Tooltip>
  )
}

export default HoverTooltip